module.exports = __webpack_public_path__ + "img/tm.b5f6529.svg";